import { PodesavanjaArhivskeDokumentacijeService } from './../../../../../../form-definitions/src/lib/racun/konfiguracija/podesavanja-arhivske-dokumentacije-service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ArhivskaKnjigaClient, IPodesavanjaArhivskeDokumentacijeDto, ResultOfPodesavanjaArhivskeDokumentacijeDto, UpdatePodesavanjaArhivskeDokumentacijeCommand } from '@kodit/core/data-api';
import { FormHelper } from '@kodit/core/form-definitions';
import { AlertService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { OpstaPravilaArhivskaFormService } from 'libs/core/form-definitions/src/lib/racun/konfiguracija/opsta-pravila-arhivska-form-service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-dokumentacija-arhivske-form',
  templateUrl: './dokumentacija-arhivske-form.component.html',
  styleUrls: ['./dokumentacija-arhivske-form.component.scss']
})
export class DokumentacijaArhivskeFormComponent implements OnInit, OnDestroy{

  private _subs: Subscription = new Subscription();

   form: FormGroupTypeSafe<IPodesavanjaArhivskeDokumentacijeDto>;

   constructor(
       public _dialogRef: DynamicDialogRef,
       public _dialogConfig: DynamicDialogConfig,
       private _alertService: AlertService,
       private _client: ArhivskaKnjigaClient,
       private _fs: PodesavanjaArhivskeDokumentacijeService,
       private _formHelper: FormHelper
   ) { }

   ngOnInit(): void {
      this._subs.add(
        this._client.getPodesavanjaArhivskeDokumentacija().subscribe((res) => {
          if (res.succeeded) {
            this.form = this._fs.GetPodesavanjaArhivskeDokumentacijeFormGroup(res.data!);
          }
        })
      );

      this._subs.add(
        this._dialogRef.onSubmit.subscribe(() => {
          this.save();
        })
      );
   }

   private save() {
     if (!this.form.valid) {
       this._formHelper.invalidateForm(this.form);
       return;
     }

     this._subs.add(
       this._client
         .updatePodesavanjaArhivskeDokumentacije(this.form.value as UpdatePodesavanjaArhivskeDokumentacijeCommand)
         .subscribe(
           (result: ResultOfPodesavanjaArhivskeDokumentacijeDto) => {
             if(result.succeeded){
               this._alertService.addSuccessMsg(result.messages[0]);
             }else{
               this._alertService.addWarnMsg(result.messages[0]);
             }
             this._dialogRef.close(result.data);
           },
           (error) => {
             this._subs.add(
               error.subscribe((x: string) => {
                 this._alertService.addFailedMsg(x);
               })
             );
           }
         )
     );
   }

   ngOnDestroy(): void {
     this._subs.unsubscribe();
   }

}
